export type AlertStatus = "success" | "warning" | "danger" | "primary" | "secondary" | "default" | "info";

type Colors = NonNullable<Required<AlertStatus>>;

export const alertBackgroundColorMap: Record<Colors, string> = {
    primary: "bg-primary",
    success: "bg-green-100",
    danger: "bg-red-100",
    warning: "bg-orange-100",
    secondary: "bg-secondary-50",
    default: "bg-base-200",
    info: "bg-blue-100",
};

export const alertTextColorMap: Record<Colors, string> = {
    primary: "text-white",
    success: "text-green-800",
    danger: "text-red-700",
    warning: "text-orange-900",
    secondary: "text-secondary-content",
    default: "",
    info: "text-blue-800",
};
